import { Injectable } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { NotificationItemType } from '../models/notifications-type.model';

const LOTTIE_TYPES = ['treasure', 'gift'] as const;
type LottieType = (typeof LOTTIE_TYPES)[number];

@Injectable({ providedIn: 'root' })
export class LottiePreloaderService {
  private readonly cache: Map<LottieType, object> = new Map<LottieType, object>();

  constructor() {
    for (const type of LOTTIE_TYPES) {
      fetch(`/lotties/${type}.json`)
        .then((response: Response) => response.json())
        .then((data: object) => this.cache.set(type, data));
    }
  }

  getOptions(type: NotificationItemType, loop: boolean = false): AnimationOptions | undefined {
    if (!LOTTIE_TYPES.includes(type as LottieType)) return undefined;
    const animationData: object | undefined = this.cache.get(type as LottieType);
    return animationData ? { animationData, loop } : undefined;
  }
}
